<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold" align="left"> 单据编号:{{ this.$route.query.fbillno }}</h1>
    <a-table :columns="columns" :data-source="data" :loading="loading" :style="{background:'url('+imagePath+')'}">
      <a slot="fid" slot-scope="text" @click="closeSchmearpost(text)">{{ text }}</a>
    </a-table>
    <br/>
    <a-button type="primary" @click="createSchmearpost()">
      添加事务
    </a-button>
    <a-button type="primary" @click="selectYNhPickDataByFMOBILLNO()">
      查看发料清单
    </a-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "schmearpost",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      data: [],
      loading: true,
      columns: [
        {
          title: '编号',
          dataIndex: 'fid',
          key: 'fid',
          scopedSlots: {customRender: 'fid'},
        },
        {
          title: '创建人',
          dataIndex: 'fcreateuser',
          key: 'fcreateuser',
        },
        {
          title: '事务类型',
          dataIndex: 'fposttype',
          key: 'fposttype',
        },
        {
          title: '事务分类',
          dataIndex: 'fspecificationtype',
          key: 'fspecificationtype',
        },
        {
          title: '结案人',
          dataIndex: 'fproxycloseuser',
          key: 'fproxycloseuser',
        },
        {
          title: '结案状态',
          dataIndex: 'fresult',
          key: 'fresult',
        },
      ]
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-schmearpost/selectTSchmearpostByFbillno?fbillno=" + this.$route.query.fbillno)
      .then((res) => {
        this.loading = false;
        this.data = res.data.data;
      })
  },
  methods: {
    closeSchmearpost(fid) {
      window.location.href = "http://www.tcnanhua.com:5555/ui/schmearpostClose?fid=" + fid;
    },
    createSchmearpost() {
      // encodeURIComponent
      // window.location.href="http://www.tcnanhua.com:5555/ui/schmearpostCreate?fbillno="+this.$route.query.fbillno;
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww1ae80eccc8c19cbe&redirect_uri=" + encodeURIComponent("www.tcnanhua.com:5555/ui/schmearpostCreate?fbillno=" + this.$route.query.fbillno) + "&response_type=code&scope=snsapi_base&state=#wechat_redirect";
    },
    selectYNhPickDataByFMOBILLNO(){
      // window.location.href = "http://www.tcnanhua.com:5555/ui/schmearpostClose?fid=" + fid;
      window.location.href = "http://www.tcnanhua.com:5555/ui/pickdata?fbillno=" + this.$route.query.fbillno;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Schmearpost.vue